/**
 * Adds a diagonal watermark to a jsPDF document instance.
 * Call AFTER all pages are added, BEFORE doc.save().
 * @param {jsPDF} doc - The jsPDF document instance
 * @param {string} classification - The classification level
 */
export const addWatermarkToAllPages = (doc, classification) => {
  if (!classification || classification === 'unclassified') return;

  const watermarkConfig = {
    internal:     { text: 'INTERNAL',     color: [150, 150, 150], opacity: 0.08 },
    confidential: { text: 'CONFIDENTIAL', color: [255, 140, 0],   opacity: 0.1  },
    restricted:   { text: 'RESTRICTED',   color: [220, 50,  50],  opacity: 0.12 },
    secret:       { text: 'SECRET',       color: [180, 0,   0],   opacity: 0.15 },
  };

  const config = watermarkConfig[classification];
  if (!config) return;

  const pageCount = doc.internal.getNumberOfPages();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    const pageWidth  = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Save graphics state via GState
    doc.saveGraphicsState();
    doc.setGState(new doc.GState({ opacity: config.opacity }));
    doc.setTextColor(...config.color);
    doc.setFontSize(60);
    doc.setFont('helvetica', 'bold');

    // Diagonal watermark (center of page, rotated 45 degrees)
    doc.text(config.text, pageWidth / 2, pageHeight / 2, {
      align: 'center',
      angle: 45,
    });

    // Second watermark for larger pages
    if (pageHeight > 200) {
      doc.text(config.text, pageWidth / 2, pageHeight / 4, {
        align: 'center',
        angle: 45,
      });
      doc.text(config.text, pageWidth / 2, (pageHeight * 3) / 4, {
        align: 'center',
        angle: 45,
      });
    }

    doc.restoreGraphicsState();

    // Add classification header/footer on each page
    doc.setGState(new doc.GState({ opacity: 1 }));
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...config.color);
    doc.text(`[${config.text}]`, pageWidth / 2, 8, { align: 'center' });
    doc.text(`[${config.text}]`, pageWidth / 2, pageHeight - 4, { align: 'center' });
  }
};
